import './balance.css'

import PlayStory from '../play/PlayStory'
import { BALANCE_COPY } from './copy'
import { Chain, MoreHuman, Paradox, Proof, Start, Voices, Week } from './scenes'

/**
 * Version „Aivy Balance“: Kund:innen wollen mehr Menschlichkeit und mehr
 * Automatisierung zugleich. Die Geschichte zeigt, dass das zusammengeht,
 * weil Aivy die Arbeit an Unterlagen übernimmt und die Zeit an Menschen geht.
 * Grundlage sind Kundengespräche und Feedback-Signale, anonymisiert.
 */
const SECTIONS = [
  { id: 'paradox', height: 300, tone: 'white', Scene: Paradox },
  { id: 'stimmen', height: 320, Scene: Voices },
  { id: 'woche', height: 620, tone: 'white', Scene: Week },
  { id: 'menschlicher', height: 320, Scene: MoreHuman },
  { id: 'kette', height: 340, tone: 'white', Scene: Chain },
  { id: 'belege', height: 260, tone: 'blue', Scene: Proof },
  { id: 'start', flow: true, tone: 'white', Scene: Start }
]

export default function AivyBalance() {
  return <PlayStory sections={SECTIONS} copy={BALANCE_COPY} />
}
